import { Routes } from '@angular/router';
import { AuthGuardChildFn, AuthGuardFn } from '../utils/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    loadChildren: () =>
      import('../views/pages/dashboards/dashboards.module').then((m) => m.DashboardsModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('../views/pages/profiles/profiles.module').then((m) => m.ProfilesModule),
  },
  {
    path: '',
    canActivate: [AuthGuardFn],
    canActivateChild: [AuthGuardChildFn],
    loadChildren: () =>
      import('../views/pages/users/users.module').then((m) => m.UsersModule),
  },
  {
    path: '',
    canActivate: [AuthGuardFn],
    canActivateChild: [AuthGuardChildFn],
    loadChildren: () =>
      import('../views/pages/roles/roles.module').then((m) => m.RolesModule),
  },
  {
    path: '',
    canActivate: [AuthGuardFn],
    canActivateChild: [AuthGuardChildFn],
    loadChildren: () =>
      import('../views/pages/countries/countries.module').then((m) => m.CountriesModule),
  },
  {
    path: '',
    canActivate: [AuthGuardFn],
    canActivateChild: [AuthGuardChildFn],
    loadChildren: () =>
      import('../views/pages/transaction-fees/transaction-fees.module').then((m) => m.TransactionFeesModule),
  },
  {
    path: '',
    canActivate: [AuthGuardFn],
    canActivateChild: [AuthGuardChildFn],
    loadChildren: () =>
      import('../views/pages/payout-partners/payout-partners.module').then((m) => m.PayoutPartnersModule),
  },
  {
    path: '',
    canActivate: [AuthGuardFn],
    canActivateChild: [AuthGuardChildFn],
    loadChildren: () =>
      import('../views/pages/system-limits/system-limits.module').then((m) => m.SystemLimitsModule),
  },
  {
    path: '',
    canActivate: [AuthGuardFn],
    canActivateChild: [AuthGuardChildFn],
    loadChildren: () =>
      import('../views/pages/applications/applications.module').then((m) => m.ApplicationsModule),
  },
  {
    path: '',
    canActivate: [AuthGuardFn],
    canActivateChild: [AuthGuardChildFn],
    loadChildren: () =>
      import('../views/pages/notifications/notifications.module').then((m) => m.NotificationsModule),
  },
  {
    path: '',
    canActivate: [AuthGuardFn],
    canActivateChild: [AuthGuardChildFn],
    loadChildren: () =>
      import('../views/pages/exchange-rates/exchange-rates.module').then((m) => m.ExchangeRatesModule),
  },
  {
    path: '',
    canActivate: [AuthGuardFn],
    canActivateChild: [AuthGuardChildFn],
    loadChildren: () =>
      import('../views/pages/campaigns/campaigns.module').then((m) => m.CampaignsModule),
  },
  {
    path: '',
    canActivate: [AuthGuardFn],
    canActivateChild: [AuthGuardChildFn],
    loadChildren: () =>
      import('../views/pages/customers/customers.module').then((m) => m.CustomersModule),
  },
  {
    path: '',
    canActivate: [AuthGuardFn],
    canActivateChild: [AuthGuardChildFn],
    loadChildren: () =>
      import('../views/pages/kyc-updates/kyc-updates.module').then((m) => m.KycUpdatesModule),
  },
  {
    path: '',
    canActivate: [AuthGuardFn],
    canActivateChild: [AuthGuardChildFn],
    loadChildren: () =>
      import('../views/pages/monitorings/monitorings.module').then((m) => m.MonitoringsModule),
  },
  {
    path: '',
    canActivate: [AuthGuardFn],
    canActivateChild: [AuthGuardChildFn],
    loadChildren: () =>
      import('../views/pages/orders/orders.module').then((m) => m.OrdersModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('../views/pages/homes/homes.module').then((m) => m.HomesModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('../views/pages/samples/samples.module').then((m) => m.SamplesModule),
  },
  {
    path: 'auth',
    canActivate: [AuthGuardFn],
    canActivateChild: [AuthGuardChildFn],
    loadChildren: () =>
      import('../views/pages/authentications/authentications.module').then((m) => m.AuthenticationsModule),
  },
  {
    path: 'misc',
    loadChildren: () =>
      import('../views/pages/miscellaneous/miscellaneous.module').then((m) => m.MiscellaneousModule),
  },
  {
    path: '**',
    redirectTo: '/misc/not-found',
    pathMatch: 'full',
  },
];
